import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";

type Props = $Exact<{
  charts: [],
}>;

export class SlaInteractionsBarchart extends React.Component<Props> {
  render() {
    return (
      <div className="department-details-report-table center-aligned-text w-100">
        {this.props.charts.length < 1 ? (
          <h3>{this.props.t("NO_DATA_PLEASE_APPLY_FILTERS")}</h3>
        ) : (
          <Chart
            type="ColumnChart"
            title={this.props.t("INTERACTIONS_BY_TYPE")}
            values={[
              [
                "Type",
                this.props.t("TOTAL_INBOUND_INTERACTIONS"),
                this.props.t("TOTAL_AUTO_CALLBACKS"),
                this.props.t("TOTAL_ASAP_CALLBACKS"),
                this.props.t("TOTAL_SCHEDULED_CALLBACKS"),
              ],
              ...[
                ...this.props.charts
                  .filter(rec => rec.month !== "Period Total")
                  .map(i => [
                    i.month,
                    parseFloat(i.totalInboundInteractions),
                    parseFloat(i.totalAutoCallbacks),
                    parseFloat(i.totalAsapCallbacks),
                    parseFloat(i.totalScheduledCallbacks),
                  ]),
              ],
            ]}
            options={{
              isStacked: true,
              legend: { position: "top" },
              chartArea: { width: "90%" },
            }}
            chartHeight={300}
          />
        )}
      </div>
    );
  }
}

export default localize()(SlaInteractionsBarchart);
